require('./mortgageRequestFormModal.scss');
require('./mortgageRequestFormModal.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const { ModalCustom } = require('commonsComponents/modalCustom');

// @core
const { formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');

//@components
const MortgageRequestProgressBar = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestProgressBar/mortgageRequestProgressBar');
const { OKButton } = require('components/commons/OKButton/OKButton');

//@constants
const { DATE_OF_BIRTH, OTHER_LOANS_AND_MORTGAGES } = require('constants/mortgageRequestPreApproval').idModalsMortgageRequest;

class MortgageRequestFormModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleShowNextModal = this.handleShowNextModal.bind(this);
        this.handleShowPreviousModal = this.handleShowPreviousModal.bind(this);
        this.handleSaveModal = this.handleSaveModal.bind(this);
        this.handleRequestClose = this.handleRequestClose.bind(this);
    }

    handleShowNextModal() {
        const {
            isNavigationButtonsAvailable,
            nextModal,
            currentModal,
            onHandleChangeModalActive,
            onHandleValidateObligatoryFields,
            onHandleActionPreviousNextButton,
            clearTemporalChangesInCurrentModal
        } = this.props;

        if (isNavigationButtonsAvailable) {
            onHandleValidateObligatoryFields(currentModal);
            onHandleChangeModalActive(nextModal);
            onHandleActionPreviousNextButton(true);
            clearTemporalChangesInCurrentModal();
        }
    }

    handleShowPreviousModal() {
        const {
            isNavigationButtonsAvailable,
            previousModal,
            currentModal,
            onHandleChangeModalActive,
            onHandleValidateObligatoryFields,
            onHandleActionPreviousNextButton,
            clearTemporalChangesInCurrentModal
        } = this.props;

        if (isNavigationButtonsAvailable) {
            onHandleValidateObligatoryFields(currentModal);
            onHandleChangeModalActive(previousModal);
            onHandleActionPreviousNextButton(true);
            clearTemporalChangesInCurrentModal();
        }
    }

    shouldSaveBirthDayData() {
        const { getDateValidity, temporalHolderBirthDates, currentModal } = this.props;
        const isBirthdayModal = currentModal === DATE_OF_BIRTH;

        if (!isBirthdayModal) {
            return true;
        }

        const holderOne = temporalHolderBirthDates[0];
        const holderTwo = temporalHolderBirthDates[1];
        const holderOneDateValidity = getDateValidity(
            holderOne.dayOfBirth,
            holderOne.monthOfBirth,
            holderOne.yearOfBirth
        );
        const holderTwoDateValidity = getDateValidity(
            holderTwo.dayOfBirth,
            holderTwo.monthOfBirth,
            holderTwo.yearOfBirth
        );
        const shouldSaveModalDataValue = ((() => {
            let shouldSave = true;
            const holderOneIsAdult = holderOneDateValidity.legalAge;
            const holderTwoIsAdult = holderTwoDateValidity.legalAge;
            const errorInFirstHolder = (!holderOneDateValidity.validDate || !holderOneIsAdult) && !holderOneDateValidity.isEmpty;
            const errorInSecondHolder = (!holderTwoDateValidity.validDate || !holderTwoIsAdult) && !holderTwoDateValidity.isEmpty;

            if (isBirthdayModal && (errorInFirstHolder || errorInSecondHolder)) {
                shouldSave = false;
            }

            return shouldSave;
        })());

        return shouldSaveModalDataValue;
    }

    handleSaveOnOtherModal() {
        const {
            currentModal,
            immMortgageRequest,
            handlerInfoOtherLoansMortgages
        } = this.props;

        if (currentModal === 'otherLoansAndMortgages') {
            const holders = immMortgageRequest.get('holders');

            holders.forEach((holder, index) => {
                const havePersonalLoans = holder.get('personalLoans');
                const haveOtherMortgage = holder.get('otherMortgage');
                if (havePersonalLoans === 'no') {
                    handlerInfoOtherLoansMortgages(index.toString(), 'monthlyFeesLoans', 0);
                    handlerInfoOtherLoansMortgages(index.toString(), 'pendingAmountLoans', 0);
                }
                if (haveOtherMortgage === 'no') {
                    handlerInfoOtherLoansMortgages(index.toString(), 'monthlyFeesMortgage', 0);
                    handlerInfoOtherLoansMortgages(index.toString(), 'pendingAmountMortgage', 0);
                }
            });
        }
    }

    handleSaveModal() {
        const {
            clearTemporalChangesInCurrentModal,
            isNavigationButtonsAvailable,
            onHandleToggleModal
        } = this.props;

        if (!this.shouldSaveBirthDayData() || !isNavigationButtonsAvailable) {
            return;
        }

        this.handleSaveOnOtherModal();
        onHandleToggleModal();
        clearTemporalChangesInCurrentModal();
    }

    buildNextButton(currentModal) {
        const nextText = toFirstUppercase(formatText('buttonsActions-next'));
        const { immMortgageRequest } = this.props;
        const idModalActive = immMortgageRequest.get('isModalActive');
        const validModals = immMortgageRequest.get('validModals');
        const isCompleteStep = validModals.getIn([idModalActive, 'filled'], false);
        const show = currentModal != OTHER_LOANS_AND_MORTGAGES && !isCompleteStep;
        const isModalFromPreviousNextAction = (immMortgageRequest.get('actionPreviousNextButton') && currentModal !== OTHER_LOANS_AND_MORTGAGES);
        return (isModalFromPreviousNextAction || show) ? (
            <OKButton modifier="secondary" rightIcon="icon-siguiente" onClick={this.handleShowNextModal}>
                {nextText}
            </OKButton>
        ) : null;
    }

    buildPreviousButton(currentModal) {
        const { immMortgageRequest } = this.props;
        const idModalActive = immMortgageRequest.get('isModalActive');
        const validModals = immMortgageRequest.get('validModals');
        const isCompleteStep = validModals.getIn([idModalActive, 'filled'], false);
        const backText = toFirstUppercase(formatText('buttonsActions-previous'));
        const show = (currentModal != DATE_OF_BIRTH) && !isCompleteStep;
        const isModalFromPreviousNextAction = (immMortgageRequest.get('actionPreviousNextButton') && currentModal !== DATE_OF_BIRTH);
        return (isModalFromPreviousNextAction || show) ? (
            <OKButton modifier="ghost" leftIcon="icon-anterior" onClick={this.handleShowPreviousModal}>
                {backText}
            </OKButton>
        ) : null;
    }

    buildSaveButton(currentModal) {
        const { immMortgageRequest } = this.props;
        const saveText = toFirstUppercase(formatText('common-save'));
        const idModalActive = immMortgageRequest.get('isModalActive');
        const validModals = immMortgageRequest.get('validModals');
        const isCompleteStep = validModals.getIn([idModalActive, 'filled'], false);
        const isModalFromPreviousNextAction = immMortgageRequest.get('actionPreviousNextButton');
        let show = currentModal === OTHER_LOANS_AND_MORTGAGES || isCompleteStep;

        if (currentModal === DATE_OF_BIRTH && !show && isModalFromPreviousNextAction) {
            show = !isModalFromPreviousNextAction;
        } else if (currentModal !== OTHER_LOANS_AND_MORTGAGES && isModalFromPreviousNextAction) {
            show = !isModalFromPreviousNextAction;
        } else if (currentModal !== OTHER_LOANS_AND_MORTGAGES && !isModalFromPreviousNextAction && show) {
            show = true;
        }
        return show ? (
            <OKButton modifier="primary" onClick={this.handleSaveModal}>
                {saveText}
            </OKButton>
        ) : null;
    }

    handleRequestClose(event) {
        const { onHandleToggleModal } = this.props;
        onHandleToggleModal(event, { fromClose: true });
    }

    render() {
        const { showModal, children, immMortgageRequest, currentModal, responsiveMobileVersion } = this.props;
        const nextButton = this.buildNextButton(currentModal);
        const previousButton = this.buildPreviousButton(currentModal);
        const saveButton = this.buildSaveButton(currentModal);

        return (
            <ModalCustom
                extraClass={responsiveMobileVersion ? 'mortgage-request-form-modal__size-modal ' : 'mortgage-request-form-modal__size-modal'}
                isOpen={showModal}
                onRequestClose={this.handleRequestClose}
                closeOnOverlay
            >
                <div className='mortgage-request-form-modal__flex-modal' >

                    <div className="mortgage-request-form-modal__size-modal-children">
                        {children}
                    </div>


                    <div>
                        <div className="mortgage-request-form-modal__separator-line" />
                        <div className={responsiveMobileVersion ? 'col-md-12' : "col-md-6"}>
                            <MortgageRequestProgressBar immMortgageRequest={immMortgageRequest} responsiveMobileVersion={responsiveMobileVersion} />
                        </div>
                        <div className={responsiveMobileVersion ? "col-md-12 mortgage-request-form-modal__buttons-responsive" : "col-md-6 mortgage-request-form-modal__buttons"}>
                            {previousButton}
                            {nextButton}
                            {saveButton}
                        </div>
                    </div>
                </div>

            </ModalCustom>
        )
    }
}

MortgageRequestFormModal.propTypes = {
    children: PropTypes.element.isRequired,
    clearTemporalChangesInCurrentModal: PropTypes.func,
    currentModal: PropTypes.string,
    getDateValidity: PropTypes.func,
    handlerInfoOtherLoansMortgages: PropTypes.func,
    immMortgageRequest: PropTypes.object.isRequired,
    isNavigationButtonsAvailable: PropTypes.bool,
    nextModal: PropTypes.string,
    onHandleActionPreviousNextButton: PropTypes.func.isRequired,
    onHandleChangeModalActive: PropTypes.func.isRequired,
    onHandleDependents: PropTypes.func,
    onHandleToggleModal: PropTypes.func.isRequired,
    onHandleValidateObligatoryFields: PropTypes.func.isRequired,
    previousModal: PropTypes.string,
    showModal: PropTypes.bool,
    temporalHolderBirthDates: PropTypes.object,
};

MortgageRequestFormModal.defaultProps = {
    handlerInfoOtherLoansMortgages: () => { }
}

module.exports = MortgageRequestFormModal;
